export default function PHP_Strings() {
  return (
    <div>
      <h1>PHP_Strings</h1>
    </div>
  );
}
